import React from 'react'
import { connect } from 'react-redux' 
import { Redirect } from 'react-router-dom'
import {
  setDisplayName,
  branch,
  renderComponent,
  compose
} from 'recompose'
import { getIsLoggedInO365 } from 'Features/auth/selectors'

const RedirectToLogin = () => <Redirect to='/logino365' />
const withAuthCheckO365 = WrappedComponent => props => (
  <WrappedComponent {...props} />
)

export default WrappedComponent => compose(
  setDisplayName('withAuthCheckO365'),
  connect(
    state => ({
        isLoggedInO365: getIsLoggedInO365(state)
    })
  ),
  branch(
    ({ isLoggedInO365 }) => isLoggedInO365,
    withAuthCheckO365,
    renderComponent(RedirectToLogin)
  )
)(WrappedComponent)


// WEBPACK FOOTER //
// ./src/lib/withAuthCheckO365.js